import React from 'react';

const UrgentDeliveryDisclaimer = () => {
   return ( <div className='mt-1'>
        <p>
            {"<<Message to be confirmed>>"}
        </p>
    </div>);
};
export default UrgentDeliveryDisclaimer;